import React from 'react';
import styled from 'styled-components';
import { CardsContainer } from '../ui/CardsLayout/styled';
import { ItemCardStyled } from '../ui/ItemCard/styled';
import { ItemCardSkeletonBody } from './ItemCardPlaceholder';
import {
  PlaceholderCardPrice,
  PlaceholderCardLocation,
  PlaceholderCardDescription
} from './ItemCardPlaceholder/styled';

interface EndlessItemsPlaceholderProps {
  count: number;
  container?: React.ElementType;
  containerProps?: Record<string, boolean>;
}

const SkeletonItemCard = styled(ItemCardStyled)`
  ${PlaceholderCardPrice} {
    height: 20px;
  }

  ${PlaceholderCardLocation}, ${PlaceholderCardDescription} {
    height: 18px;
  }
`;

export const endlessItemsPlaceholderCards = (count: number) =>
  Array.from({ length: count }, (_, index) => (
    <SkeletonItemCard key={index}>
      <ItemCardSkeletonBody />
    </SkeletonItemCard>
  ));

export const EndlessItemsPlaceholder: React.FC<
  EndlessItemsPlaceholderProps
> = ({ count, container: Container = CardsContainer, containerProps }) => (
  <Container {...containerProps}>
    {endlessItemsPlaceholderCards(count)}
  </Container>
);
